"use client";

import React from "react";

import { createSVGIcon } from "./util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const LGBTQOwned = createSVGIcon(
  <>
    <path
      d="M3 14.636C3 9.865 6.672 6 11.205 6s8.204 3.865 8.204 8.636z"
      fill="#D4D9E4"
    />
    <path
      d="M6.971 16.727a7.27 7.27 0 0 1 7.256-6.773c3.85 0 7 2.988 7.256 6.773z"
      stroke="#312921"
    />
  </>,
  "LBGTQ owned",
  {
    viewBox: "0 0 24 24",
    titleAccess: "LBGTQ owned",
    fill: "none",
  }
);
